'use client';

import { SpinnerIcon } from '@app/app/_icons/SpinnerIcon';

interface Props {
    isVisible: boolean;
    text?: string;
    onAnimationEnd?: () => void;
}

export function GlobalLoader({ isVisible, text, onAnimationEnd }: Props) {
    if (!isVisible) {
        return null;
    }

    return (
        <div
            className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm"
            onAnimationEnd={onAnimationEnd}>
            <div className="flex flex-col items-center gap-4 rounded-lg bg-white p-8 shadow-xl">
                <SpinnerIcon className="size-12 animate-spin text-primary-500" />
                {text && <span className="text-gray-900 text-center text-lg font-medium">{text}</span>}
            </div>
        </div>
    );
}
